export default __webpack_public_path__ + "static/media/hmd.a3073b5b.svg";